module.exports = __webpack_public_path__ + "img/32.beb2d8be.jpg";